import { z } from 'zod';

interface ActivityGradingThreshold {
  perfect: number;
  excellent: number;
  good: number;
  min: number;
}

export class ActivityGradingCriteria {
  constructor(public threshold: ActivityGradingThreshold) {
    this.threshold = threshold;
  }

  public static zodSchema = z.object({
    threshold: z.object({
      perfect: z.number(),
      excellent: z.number(),
      good: z.number(),
      min: z.number(),
    }),
  });

  public static fromJson(json: unknown): ActivityGradingCriteria {
    const validJson = this.check(json);
    const activityGradingCriteria = new ActivityGradingCriteria(validJson.threshold);
    return activityGradingCriteria;
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }
}
